import React from "react";

function VideoUnmute() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="47"
      height="47"
      viewBox="0 0 47 47"
    >
      <g id="sound_on" data-name="sound on" transform="translate(0 0)">
        <circle
          id="Ellipse_327"
          data-name="Ellipse 327"
          cx="23.5"
          cy="23.5"
          r="23.5"
          transform="translate(0 0)"
          opacity="0.7"
        />
        <path
          id="Path_24833"
          data-name="Path 24833"
          d="M1.964,15.552H5.713l5.1,4.176a.482.482,0,0,0,.787-.373V4.037a.482.482,0,0,0-.787-.373L5.713,7.84H1.964A.964.964,0,0,0,1,8.8v5.784A.964.964,0,0,0,1.964,15.552ZM22.209,11.7a10.579,10.579,0,0,1-3.6,7.965l-1.367-1.367a8.677,8.677,0,0,0,0-13.2l1.367-1.367A10.579,10.579,0,0,1,22.209,11.7Zm-4.82,0a5.774,5.774,0,0,0-2.2-4.544L13.806,8.53a3.857,3.857,0,0,1,0,6.332l1.378,1.378A5.774,5.774,0,0,0,17.389,11.7Z"
          transform="translate(12 11.445)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default VideoUnmute;
